import React from 'react';
import ModalContentBase from '../modal_content_base';
import ModalLoader from '../modal_loader';
import ModalAlert from '../modal_alert';
import axios from '../../../../axios';

const PaidJoinRequest = (props) => {
  const {
    isJoinRequestSent,
    isRecruiting,
    isRequestRequired,
    circleId,
    currentUser,
    hasPayjp,
    circleJoinFee,
    pointAmount,
    registerCreditCardUrl,
    payjpLast4,
    payjpExp,
  } = props;
  const modalJoinRequest = React.useRef(null);
  const disableJoinErrorAlertRef = React.useRef(null);
  const modalLoaderRef = React.useRef(null);
  const systemErrorAlertRef = React.useRef(null);
  const joinRequestSuccessRef = React.useRef(null);
  const [familyname, setFamilyname] = React.useState(currentUser.familyname);
  const [firstname, setFirstname] = React.useState(currentUser.firstname);
  const [message, setMessage] = React.useState('');
  const [pointChecked, setPointChecked] = React.useState(true);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  // 完了モーダルで「承認期限（あと◯日）」を出すためのサーバ返却値。
  const [applicationDeadline, setApplicationDeadline] = React.useState('');
  const [applicationDaysLeft, setApplicationDaysLeft] = React.useState(null);

  const sendMemberJoinRequest = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    modalJoinRequest.current.closeModal();
    modalLoaderRef.current.openModal();

    axios
      .post('/api/circle/send_join_request', {
        circle_id: circleId,
        self_introduction: message,
        familyname: familyname,
        firstname: firstname,
        request_from_payment_form: true,
        isPointUsed: pointChecked,
      })
      .then((res) => {
        modalLoaderRef.current.closeModal();
        if (res && res.data) {
          setApplicationDeadline(res.data.memberApplicationDeadline || '');
          setApplicationDaysLeft(
            res.data.memberApplicationDaysLeft == null
              ? null
              : res.data.memberApplicationDaysLeft
          );
        }
        joinRequestSuccessRef.current.openModal();
      })
      .catch((err) => {
        setIsSubmitting(false);
        modalLoaderRef.current.closeModal();
        console.log(err.response, err.response.data);
        if (err.response && err.response.status === 403) {
          disableJoinErrorAlertRef.current.openModal();
        } else {
          systemErrorAlertRef.current.openModal();
        }
      });
  };

  const sendMemberJoinImmediately = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    modalJoinRequest.current.closeModal();
    modalLoaderRef.current.openModal();

    axios
      .post('/api/circle/send_join_immediately', {
        circle_id: circleId,
        self_introduction: message,
        familyname: familyname,
        firstname: firstname,
        request_from_payment_form: true,
        isPointUsed: pointChecked,
      })
      .then(() => {
        modalLoaderRef.current.closeModal();
        joinRequestSuccessRef.current.openModal();
      })
      .catch((err) => {
        setIsSubmitting(false);
        modalLoaderRef.current.closeModal();
        if (err.response && err.response.status === 403) {
          disableJoinErrorAlertRef.current.openModal();
        } else {
          systemErrorAlertRef.current.openModal();
        }
      });
  };

  const userNameForm = React.useMemo(() => {
    if (currentUser.familyname === null || currentUser.firstname === null) {
      return (
        <div>
          <p className="mt20 bold red" style={{ textAlign: 'left' }}>
            <i className="fas fa-exclamation-triangle" />
            &nbsp;まだお名前の登録が完了していません。
          </p>
          <div
            className="flex mt10 width-full"
            style={{ alignItems: 'center' }}
          >
            <p>
              <i className="fas fa-user mr10" />
            </p>
            <input
              type="text"
              placeholder="姓"
              className="mr5"
              style={{ width: '50%', padding: '5px' }}
              onChange={(e) => setFamilyname(e.target.value)}
              value={familyname}
            />
            <input
              type="text"
              placeholder="名"
              style={{ width: '50%', padding: '5px' }}
              onChange={(e) => setFirstname(e.target.value)}
              value={firstname}
            />
          </div>
        </div>
      );
    }
  }, [currentUser, familyname, firstname]);

  const modalContent = React.useMemo(() => {
    if (!isJoinRequestSent && isRecruiting) {
      // まだメンバー申請していない && メンバー募集中

      if (isRequestRequired) {
        // メンバー申請が必要
        return (
          <div className="card bg-gray" style={{ padding: '16px 16px 100px' }}>
            <button
              type="button"
              className="close close__modal position-absolute position--modalclose"
              aria-label="Close"
              onClick={() => modalJoinRequest.current.closeModal()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h6 className="text-fw-bold text-center mb-3_5">
              メンバー申請する（参加手数料 ￥{circleJoinFee}）
            </h6>
            <p className="text-black-50 text-fz-12px text-center mb-3">
              このサークルは承認制です。お支払い後は「承認待ち」となり、主催者が承認するとメンバーになります。
            </p>
            {userNameForm}
            <div className="card bg-white scrollable-list-y border-0 p-3 mb-2">
              <textarea
                className="textarea--eventreport"
                name=""
                id=""
                cols="30"
                rows="4"
                defaultValue={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="はじめまして、〇〇と申します。&#13;&#10;趣味は..."
              />
            </div>
            <button
              className="a-button a-button__top a-button--orange mr-auto ml-auto mt-2 mb-2 w-100"
              onClick={
                isRequestRequired
                  ? sendMemberJoinRequest
                  : sendMemberJoinImmediately
              }
              disabled={familyname === null || firstname === null || isSubmitting}
            >
              ¥{circleJoinFee}を支払って申請する
            </button>
            <p className="text-black-50 text-fz-12px mt-3 mx-auto">
              申請から7日以内に承認されない場合は、申請は自動的に取り下げられ、参加手数料は全額返金されます
            </p>
          </div>
        );
      } else {
        // メンバー申請不要（即時参加）
        return (
          <div className="card bg-gray" style={{ padding: '40px 16px 40px' }}>
            <button
              type="button"
              className="close close__modal position-absolute position--modalclose"
              aria-label="Close"
              onClick={() => modalJoinRequest.current.closeModal()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h6 className="text-fw-bold text-center mb-3_5">
              メンバーになる（参加手数料 ￥{circleJoinFee}）
            </h6>
            <p className="text-black-50 text-fz-12px text-center mb-3">
              このサークルは承認不要です。お支払いするとすぐにメンバーになります。
            </p>
            <button
              className="a-button a-button__top a-button--orange mr-auto ml-auto mt-2 mb-2 w-100"
              onClick={
                isRequestRequired
                  ? sendMemberJoinRequest
                  : sendMemberJoinImmediately
              }
              disabled={familyname === null || firstname === null || isSubmitting}
            >
              ¥{circleJoinFee}を支払ってメンバーになる
            </button>
          </div>
        );
      }
    } else if (!isRecruiting) {
      // メンバー募集していない
      return (
        <div>
          <div className="modal-view-header">
            <p
              className="bold"
              style={{ margin: '0px 0px 6px', paddingTop: '1.5em' }}
            >
              メンバー申請ができません
            </p>
          </div>
          <div className="modal-view-body" style={{ paddingBottom: '2em' }}>
            <p>このサークルは現在メンバーの募集を申請をしていません。</p>
          </div>
        </div>
      );
    } else {
      return '';
    }
  }, [
    isJoinRequestSent,
    isRecruiting,
    isRequestRequired,
    familyname,
    firstname,
    isSubmitting,
    message,
    pointChecked,
  ]);

  return (
    <>
      <div className="container col-md-8 col-lg-7 mt-3">
        <div className="container bg-gray px-4 pt-3 pb-3">
          <div className="container bg-white pt-3 pb-3">
            <div
              className="container pt-4"
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <p
                className="text-black-999 text-fz-13px pt-1"
                style={{ fontWeight: 700 }}
              >
                参加手数料
              </p>
              <p className="text-black-999 text-fz-20px">￥ {circleJoinFee}</p>
            </div>
          </div>
          <div className="container pb-1 pt-3 d-flex justify-content-between align-items-center">
            <p
              className="text-black-999 text-fz-13px mb-0"
              style={{ fontWeight: 700 }}
            >
              ポイントを使う
            </p>
            <div className="toggle_switch d-flex">
              <p className="mb-0">{pointAmount}</p>
              <span style={{ paddingRight: 12 }}>pt</span>
              <input
                type="checkbox"
                id="postTypeToggle"
                className="pl-2 toggle_input"
                checked={pointChecked}
                onChange={(e) => setPointChecked(e.target.checked)}
              />
              <label htmlFor="postTypeToggle" className="mb-0 toggle_label" />
            </div>
          </div>
        </div>
      </div>

      <div className="container col-md-8 col-lg-7 mt-3">
        <div className="border rounded p-3 bg-white">
          <p className="text-fz-13px text-fw-bold mb-2">
            <i className="fas fa-info-circle mr5" />
            {isRequestRequired
              ? 'メンバー申請についてのご案内'
              : 'メンバー登録についてのご案内'}
          </p>
          <ul className="text-fz-12px text-black-444 mb-0 pl-3">
            <li className="mb-1">
              このサークルに入るには参加手数料（￥{circleJoinFee}）がかかります。
            </li>
            <li className="mb-1">
              参加手数料をお支払いいただくと、このサークルのイベントに参加するときのイベント参加手数料が無料になります。
            </li>
            <li className="mb-1">
              VIP・プレミアム会員の方や、このサークルのイベントに参加したことがある方は参加手数料がかかりません。
            </li>
            <li className="mb-1">
              お支払いには、クレジットカードまたは PayPay
              の登録が必要です。未登録の場合は、下のボタンから登録してください。
            </li>
            {isRequestRequired ? (
              <li className="mb-0">
                お支払い後は「承認待ち」となります。申請から7日以内にサークル主催者が承認しなかった場合、申請は自動的に取り下げられ、参加手数料は全額返金されます。
              </li>
            ) : (
              <li className="mb-0">
                このサークルは承認不要のため、お支払いするとすぐにメンバーになります。
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="container bg-white pb-3 mt-3">
        <div className="container col-md-8 col-lg-7 mt-3">
          <div className="row">
            <div className="col-12 mb-2">
              <div className="border rounded p-3 h-100 shadow-sm text-white">
                {!hasPayjp ? (
                  <a
                    className="a-button a-button__top a-button--orange width-full mx-auto"
                    href={registerCreditCardUrl}
                  >
                    クレジットカードでお支払い
                  </a>
                ) : (
                  <>
                    <ModalContentBase
                      ref={modalJoinRequest}
                      hideXBtn
                      previewContent={
                        <button
                          type="button"
                          className="a-button a-button__top a-button--orange width-full mx-auto text-white"
                        >
                          <span>
                            {isRequestRequired
                              ? `メンバー申請する（参加手数料 ￥${circleJoinFee}）`
                              : `メンバーになる（参加手数料 ￥${circleJoinFee}）`}
                          </span>
                        </button>
                      }
                      modalContent={modalContent}
                    />
                    <div className="text-center mt-3">
                      <p className="text-black-444 text-fz-11px mb-0">
                        カード番号：XXXX-XXXX-XXXX-{payjpLast4}
                      </p>
                      <p className="text-black-444 text-fz-11px mb-2">
                        有効期限（MM/YY）：{payjpExp}
                        <br />
                        のクレジットカードで決済します。
                      </p>
                      <p className="text-black-444 text-fz-11px">
                        <a
                          href={registerCreditCardUrl}
                          style={{ textDecoration: 'underline' }}
                        >
                          クレジットカードの変更はこちら
                        </a>
                      </p>
                    </div>
                  </>
                )}

                <div className="container col-md-6" style={{ minWidth: 160 }}>
                  <img
                    src="/img/logo-credit_cards.png"
                    className="w-100 mb-1 mt-1 px-5"
                    alt="credit cards"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalLoader ref={modalLoaderRef} />
      <ModalAlert
        ref={systemErrorAlertRef}
        title="エラー"
        content="時間を置いてもう一度試すか、運営にお問い合わせください。"
      />
      <ModalAlert
        ref={disableJoinErrorAlertRef}
        title="エラー"
        content="お客様は、このサークルのイベントに参加する権限がございません。"
      />
      <ModalAlert
        ref={joinRequestSuccessRef}
        title={isRequestRequired ? 'メンバー申請を受け付けました' : 'メンバー登録完了'}
        content={
          isRequestRequired ? (
            <span>
              メンバー申請と参加手数料のお支払いが完了しました。
              <br />
              サークル主催者の承認をお待ちください。承認されると参加が完了します（ご自身の操作ではメンバーになれません）。
              {applicationDeadline ? (
                <>
                  <br />
                  <br />
                  {applicationDeadline}まで
                  {applicationDaysLeft != null ? `（あと${applicationDaysLeft}日）` : ''}
                  に承認されない場合は、申請は自動的に取り下げられ、参加手数料 ￥{circleJoinFee} は全額返金されます。
                </>
              ) : null}
            </span>
          ) : (
            'サークルのメンバーになりました。'
          )
        }
        approveFunc={() => {
          window && (window.location.href = `/circle/${circleId.toString()}`);
        }}
      />
    </>
  );
};

export default PaidJoinRequest;
